import { z } from "zod";

const IroncladFieldTypeEnum = z.enum([
  "string",
  "date",
  "number",
  "address",
  "email",
  "boolean",
  "document",
  "monetaryAmount",
  "duration",
  "object",
  "array",
]);

export const GetWorkflowSchemasSchema = z.object({
  list: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      schema: z.record(
        z.string(),
        z.object({
          type: IroncladFieldTypeEnum,
          displayName: z.string(),
        }),
      ),
    }),
  ),
});

export type GetWorkflowSchemas = z.infer<typeof GetWorkflowSchemasSchema>;
